export enum CurrencyType {
    Voidlings = "Voidlings",
    CombatBots = "CombatBots",
    VoidBatteries = "VoidBatteries"
}
